import { useRef } from "react";

type Primitive = string | number | boolean | null | undefined;

export function useFormDirty<T extends Record<string, Primitive>>(
  initial: T,
  current: T
): boolean {
  const initialRef = useRef<T>(initial);

  return (Object.keys(initialRef.current) as (keyof T)[]).some((key) => {
    const a = initialRef.current[key] ?? "";
    const b = current[key] ?? "";
    return String(a) !== String(b);
  });
}